<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "app",
  async beforeCreate() {
    const discordId =
      this.$store.state.discord_user && this.$store.state.discord_user.id;

    if (discordId) {
      this.axios
        .get("/api/v1/globalinfo", {
          params: {
            user_id: discordId
          }
        })
        .then(res => {
          const isPremium = res && res.data && res.data.ispremium;
          this.$store.commit("updateGlobalInfo", { isPremium: isPremium });
        })
        .catch(error => {
          this.$store.commit("updateGlobalInfo", { isPremium: false });
          console.log(error);
        });
    } else {
      this.$store.commit("updateGlobalInfo", { isPremium: false });
    }

    fetch("https://geodata.botlabs.gg", {
        withCredentials: false
      })
      .then(res => res.json())
      .then(data => {
        this.$store.commit("updateUserGeo", data);
      })
      .catch(error => {
        this.$store.commit("updateUserGeo", {});
        console.log(error);
      });
  }
};
</script>

<style lang="scss">
/* Import Font Awesome Icons Set */
$fa-font-path: "~@fortawesome/fontawesome-free/webfonts/";
@import "~@fortawesome/fontawesome-free/scss/fontawesome.scss";
@import "~@fortawesome/fontawesome-free/scss/regular.scss";
@import "~@fortawesome/fontawesome-free/scss/solid.scss";
@import "~@fortawesome/fontawesome-free/scss/brands.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";

.mini-toastr {
  top: 67px !important;
  position: fixed;
  right: 12px;
  z-index: 99999;
}
div.mini-toastr-notification__message {
  padding: 0;
}
div.mini-toastr__notification {
  opacity: 1 !important;
}

/* Header dropdowns: clip the hover background to the rounded menu shape */
.app-header .dropdown-menu {
  overflow: hidden;
}

/* ----------- Premium nav CTA (used in all header containers) ----------- */
.premium-nav-cta .nav-link {
  padding: 4px 6px !important;
  display: flex !important;
  align-items: center;
}
.premium-nav-cta__inner {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: rgba(248, 203, 0, 0.12);
  border: 1px solid rgba(248, 203, 0, 0.4);
  color: #f8cb00 !important;
  font-family: "Poppins", "Roboto", sans-serif;
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.3px;
  border-radius: 999px;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.premium-nav-cta__inner i {
  color: #f8cb00;
  font-size: 11px;
}
.premium-nav-cta .nav-link:hover .premium-nav-cta__inner,
.premium-nav-cta:hover .premium-nav-cta__inner {
  background: rgba(248, 203, 0, 0.2);
  border-color: rgba(248, 203, 0, 0.6);
  color: #ffd83d !important;
}
.premium-nav-cta .nav-link:hover .premium-nav-cta__inner i,
.premium-nav-cta:hover .premium-nav-cta__inner i {
  color: #ffd83d;
}
.premium-nav-cta .nav-link:hover {
  text-decoration: none;
}
.premium-nav-cta--icon .premium-nav-cta__inner {
  padding: 4px 9px;
}
</style>

<style>
.title {
  color: #fefefe;
  margin-top: 55px;
  font-family: poppins;
  font-weight: bold;
  font-size: 60px;
}

.subtitle {
  color: #fefefe;
  font-family: poppins;
  font-weight: bold;
  font-size: 30px;
}
.smalltitle {
  color: #fefefe;
  font-family: poppins;
  font-weight: bold;
  font-size: 22px;
}
.tinytitle {
  color: #fefefe;
  font-family: poppins;
  font-weight: bold;
  font-size: 17px;
}

.teenytinytitle {
  color: #fefefe;
  font-family: poppins;
  font-weight: bold;
  font-size: 14px;
}
</style>
